<div class="landing-page-container">
  <app-page-header title="Home">
    <div class="header-wrapper">
      <thera-dropdown
        *ngIf="showDropdown"
        [options]="dropdownOptions"
        [defaultSelection]="selectedViewId"
        (optionSelected)="onViewChange($event)"
      ></thera-dropdown>
    </div>
  </app-page-header>
    <app-tile-layout
      [firstLayoutItems]="firstLayoutItems"
      [secondLayoutItems]="secondLayoutItems"
    ></app-tile-layout>
</div>

<app-side-panel [panelDetails]="sidePanelData" (closed)="closeSidePanel()" *ngIf="sidePanelVisible" />